import React, {useState} from "react";
import { useRouteNode } from 'react-router5';
import {useTranslation} from "react-i18next";
import {getAuthorFeed} from "../api";
import {PostList} from '../post/postList';

function ProfilContributeur(){
  const { t } = useTranslation();
  const { route: {data},router } = useRouteNode();
  let user_img;

  const sendMessage = () =>{
    const jid = "user-"+data.user.id+"@localhost";
    window._converse.api.contacts.add(jid);
    window._converse.api.chats.open(jid,[],true).then(chat=>{
      router.navigate('IM');
    });
  }

  if(data.user.img === undefined || data.user.img === null){
    user_img = <span className="c-profil_img-replace">{data.user.firstname[0].toUpperCase()}{data.user.lastname[0].toUpperCase()}</span>
  }else{
    user_img = <img alt="" className="c-profil_img" style={{width: "50px", height: "50px"}} src={data.user.img} />
  }

  return(
    <div style={{display: "flex", flexDirection: "column", width: "100%"}}>
      <div className="c-profil_resume">
        <div  className="c-resume_img">
          { user_img }
          <div className="c-img_buttons">
            <a href="#h" onClick={sendMessage} className="c-button_message"> </a>
          </div>
        </div>
        <div className="c-resume_infos">
          <span className="c-infos_name">{data.user.firstname} {data.user.lastname} - {t('Utilisateur')}</span>
          <span className="c-infos_mail user">{data.user.email}</span>
        </div>
      </div>
      <div className="c-profil_authorFeed">
        <UserPostFeed users={data.users} user={data.user} bookmarks={data.bookmarks}/>
      </div>
    </div>
  )
}

const UserPostFeed = ({users,user, bookmarks}) => {
  const { t } = useTranslation();

  const [posts,setPosts] = React.useState([]);
  const [cursor,setCursor] = useState('');

  const [init, setInit] =  useState(false);


  const uniqueArray = (arr1,arr2)=>{
    let ids  = arr1.map((item)=>{return item.id});
    return  arr2.filter((item) =>{return !ids.includes(item.id);});
  }
  if(!init){
    setInit(true);
    getUserFeed();
  }

  function getUserFeed(){
    if(cursor!==false){
      getAuthorFeed(user.id, cursor).then(data=>{
        const newList = posts.concat(uniqueArray(posts,data.data));
        setCursor(data.cursor);
        setPosts(
          newList);
      });
    }
  }

  return (
    <>
    <div className="c-authorFeed_top">
      <div className="c-top_infos">
        <p>{t('Contenus du contributeur')}</p>
      </div>
      <div className="c-top_filter">
        <span className="c-filter_number">{posts.length}</span>
      </div>
    </div>
    <div className="c-authorFeed_post">
      <div className={'postfeedContainer'}>
          <div className={'postFeed'} style={{width: "100%"}}>
            {posts.length>0 && <PostList users={users} apiCall={getUserFeed} bookmarks={bookmarks} posts={posts} cursor={cursor}/>}

        </div>
      </div>
    </div>
    </>
  )
}

export default ProfilContributeur;
